import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/lotties/LandingPageLoaderLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RevampedLanding/ArticleSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RevampedLanding/LandingPage/LandingPageClientEffects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layouts/cjr-layout/CjrFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layouts/cjr-layout/CjrHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["refreshToken"] */ "/app/src/lib/api/authService.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/landing-page-widgets/carousel/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FacultySectionWidget"] */ "/app/src/widgets/landing-page-widgets/FacultySection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FounderSectionWidget"] */ "/app/src/widgets/landing-page-widgets/FounderSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalSelectionWidget"] */ "/app/src/widgets/landing-page-widgets/GoalSelection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HandsOnLearningSectionWidget"] */ "/app/src/widgets/landing-page-widgets/HandsOnLearningSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CJRLandingHeroSection"] */ "/app/src/widgets/landing-page-widgets/hero-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LearningPedagogySectionWidget"] */ "/app/src/widgets/landing-page-widgets/LearningPedagogySection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileAdStripWidget"] */ "/app/src/widgets/landing-page-widgets/MobileAdStrip/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoticeBannerWidget"] */ "/app/src/widgets/landing-page-widgets/NoticeBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/landing-page-widgets/spacing/VerticalSpacingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/widgets/landing-page-widgets/stats/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyEnrollBarWidget"] */ "/app/src/widgets/landing-page-widgets/StickyEnrollBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialSectionWidget"] */ "/app/src/widgets/landing-page-widgets/TestimonialSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustFactorBannerWidget"] */ "/app/src/widgets/landing-page-widgets/TrustFactorBanner/index.tsx");
